import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import 'bootstrap';
import VueRouter from 'vue-router';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import BootstrapVue from 'bootstrap-vue';
import routes from './router'
import * as VueSpinnersCss from "vue-spinners-css";
import moment from 'moment';
import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import DrawerLayout from 'vue-drawer-layout';
Vue.use(DrawerLayout);

import VueOnlineProp from "vue-online-prop"
Vue.use(VueOnlineProp)

window.axios = require('axios');
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common["Authorization"] = localStorage.getItem("token");

// axios interceptor code for error handling
axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const originalRequest = error.config;
  if (error.response.data.code == 401 && error.response.data.data != null && !originalRequest._retry) {
    originalRequest._retry = true;
    axios.defaults.headers.common["Authorization"] = error.response.data.data;
    originalRequest.headers["Authorization"] = error.response.data.data;
    localStorage.setItem("token", error.response.data.data);
    return axios(originalRequest);
  }
  if(originalRequest.url != "merchant/inserttransactiondetails"){
    alert(error.response.data.message);
  }
  return Promise.reject(error);
});

Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueSpinnersCss);

Vue.component('datetime', Datetime);
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD hh:mm')
  }
});
const router = new VueRouter({ mode: 'history', routes: routes });

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
